import { createReducer, on } from '@ngrx/store';
import { UserDetails } from '../../components/login/user.model';
import { getUserData, loginSuccess, logout, userData } from './user.actions';

export interface UserState {
  user: UserDetails | null;
}

export const initialUserState: UserState = {
  user: null,
};

export const userReducer = createReducer(
  initialUserState,
  on(loginSuccess, (state, { user }) => ({ ...state, user: { ...user } })),
  on(logout, (state) => ({ user: null })),
  on(getUserData, (state) => ({ ...state })),
  on(userData, (state, { user }) => {
    return { ...state, user: { ...user } };
  })
);
